import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment';
import { HttpClient } from '@angular/common/http';
import { Vitrage } from '../model/vitrage.model';
import { ConfigService } from './config.service';

@Injectable({
    providedIn: 'root',
})
export class VitragesService {

    constructor(
        protected http: HttpClient,
        private config: ConfigService
    ) {}

    getVitrages(): Observable<Vitrage[]> {
        return this
            .http
            .get<Vitrage[]>(this.config.apiEndpoint + environment.vitrage_get_collection);
    }
}
